import React from 'react'
import axios from 'axios';

const Chat = () => {


    return(
        <div className='Page'>

        </div>
    );
}

export default Chat;